import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getSubscription } from '../../../api/items';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { generateSubscriptionCIDKey } from '../../../utils/generateSubscriptionCIDKey';

export const fetchSubscription = createAsyncThunk(
  'subscription/fetchSubscription',
  async (subscriptionData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getSubscription(subscriptionData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchSubscriptionExtraReducers = builder => {
  builder
    .addCase(fetchSubscription.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.subscriptions.request,
        action,
        generateSubscriptionCIDKey(action.meta.arg.path),
      );
    })
    .addCase(fetchSubscription.fulfilled, (state, action) => {
      const subscriptionCIDKey = generateSubscriptionCIDKey(
        action.meta.arg.path,
      );

      onMatchedRequest(
        state.subscriptions.request[subscriptionCIDKey],
        action,
        () => {
          state.subscriptions.byId[subscriptionCIDKey] = action.payload;

          if (!state.subscriptions.allIds.includes(subscriptionCIDKey)) {
            state.subscriptions.allIds.push(subscriptionCIDKey);
          }
        },
      );
    })
    .addCase(fetchSubscription.rejected, (state, action) => {
      handleRequestRejection(
        state.subscriptions.request[
          generateSubscriptionCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
